import { useEffect, useState } from "react"

import { Switch, Label } from "twyne-new.ui"

const useActiveForm = item => {
  console.log({item})
  const [active, setActive] = useState(true)

  useEffect(() => {
    if (!item) return
    setActive(item.id && item.active !== undefined ? Boolean(item.active) : true)
  }, [item])

  return { active, setActive }
}

const ActiveForm = ({ active, onChangeActive }) => <>
  <div className='flex gap-2 items-center'>
    <Switch name="active" size='lg' title="Active" value={active} onChange={e => onChangeActive(e.target.checked)} />
    <Label>Active</Label>
  </div>
</>

export { useActiveForm, ActiveForm }
